/**
 * Sites that work can be put on. Lookups deliberately return parked (inactive) sites as well so that
 * history links and reactivation keep resolving, and the API has no flag to leave them out, so every
 * picker that assigns a shift, template or coverage to a site filters here.
 *
 * `keepSiteId` keeps the site an existing record already points at, even if it has since been
 * parked: dropping it would make the form's select render blank for a value it still holds.
 */
export function assignableSites<T extends { siteId: number; isActive: boolean }>(
  sites: readonly T[] | undefined,
  keepSiteId?: number | null,
): T[] {
  return (sites ?? []).filter((s) => s.isActive || s.siteId === keepSiteId)
}
